module.exports = __webpack_public_path__ + "img/skin-diagnostic-result-ru.e81641ce.jpg";